module.exports = __webpack_public_path__ + "img/Data protection Icon - white.55d16875.svg";